
/**
 * Defines how many orders will be loaded
 * each time when call the API 
 */
export const MAX_ORDER_RETRIEVE_LIMIT = 8;
